import { inExpression, all, any } from '@/services/viewer-filter'
import {
  buildWaterAccessFilters,
  buildAreaFilter,
  buildFishTypesFilter,
} from '@/fish/lib/filtering/filter-builders'

/**
 * Combine waterbody and species filters into a single Mapbox filter expression to filter fishing areas on the map
 */
export const buildFishingAreaMapboxFilter = (
  waterbodyIds: string[],
  selectedSpecies: string[]
): unknown[] => {
  const waterbodyFilter = [
    'match',
    ['get', 'data:waterbody_kg_id'],
    waterbodyIds,
    true,
    false,
  ]
  const speciesFilter = any(
    ...selectedSpecies.map((species) =>
      inExpression(species, 'data:species_slugs')
    )
  )
  return all(waterbodyFilter, speciesFilter)
}

/**
 * Combine waterbody and species filters into a single Mapbox filter expression to filter Catch Data polygons on the map
 */
export const buildCatchDataMapboxFilter = (
  waterbodyIds: string[],
  selectedSpecies: string[]
): unknown[] => {
  const waterbodyFilter = [
    'match',
    ['get', 'data:waterbody_kg_id'],
    waterbodyIds,
    true,
    false,
  ]
  const speciesFilter = any(
    ...selectedSpecies.map((species) => inExpression(species, 'data:species'))
  )
  return all(waterbodyFilter, speciesFilter)
}

/**
 * Combine expressions from access types, species, and areas
 */
export const buildFiltersForRequest = () => {
  const accessExpression = buildWaterAccessFilters()
  const fishExpression = buildFishTypesFilter()
  const areaExpression = buildAreaFilter()
  return { fishExpression, areaExpression, accessExpression }
}
